import { initialState, GovernanceState } from "./state";
import { Actions } from './actions';
import {
    GOVERNANCE_LIST, GOVERNANCE_BY_ID, GOVERNANCE_BY_FIELD_LIST,
    ADD_GOVERNANCE_RESPONSE, UPDATE_GOVERNANCE_RESPONSE, DELETE_GOVERNANCE_RESPONSE, VALIDATE_START_DATE_RESP
} from "./actionTypes";
import { SortListAscending } from "app/utils/sort.util";

export function GovernanceReducer(state = initialState, action: Actions): GovernanceState {
    switch (action.type) {
        case GOVERNANCE_LIST:
            return Object.assign({}, state, {
                governanceList: SortListAscending(action.payload, "name")
            });
        case GOVERNANCE_BY_FIELD_LIST:
            return Object.assign({}, state, {
                governanceByFieldList: SortListAscending(action.payload, "name")
            });
        case GOVERNANCE_BY_ID:
            return Object.assign({}, state, {
                governanceById: action.payload
            });
        case ADD_GOVERNANCE_RESPONSE:
            return Object.assign({}, state, {
                addGovernanceResponse: action.payload
            });
        case UPDATE_GOVERNANCE_RESPONSE:
            return Object.assign({}, state, {
                updateGovernanceResponse: action.payload
            });
        case DELETE_GOVERNANCE_RESPONSE:
            return Object.assign({}, state, {
                deleteGovernanceResponse: action.payload
            });
        case VALIDATE_START_DATE_RESP:
            return Object.assign({}, state, {
                validateStartDateResp: action.payload
            });
        default:
            return state;
    }
}
